import { render, staticRenderFns } from "./AdminDetailPassword.vue?vue&type=template&id=e567a6d8&scoped=true&"
import script from "./AdminDetailPassword.vue?vue&type=script&lang=ts&"
export * from "./AdminDetailPassword.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDetailPassword.vue?vue&type=style&index=0&id=e567a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e567a6d8",
  null
  
)

export default component.exports